export const languageKey = 'hams-root-language-key';
export const ReturnUrlPrefix = '?returnUrl=';
export const apiUrl = process.env.NODE_ENV === `development` ? 'https://localhost:44392/' : ''; //will be served from same domain!
export const signalREndpoint = apiUrl + '/signalR';
export const DrawerWidth = 200;